module.exports = __webpack_public_path__ + "media/images/products/category/sm/4-dcdc25aadce3a7d7bb9528a320463fac.jpg";